import React, { useMemo, useState } from "react";
import "../DashboardUnique.css";
import {
  exportGrantVillageWiseYojanaToExcel,
  exportVillageToExcel,
  exportVillageToPDF,
  exportYojanaToExcel,
  toIndianCurrency,
  toIndianCurrencyVillageCard,
} from "../../../MethodMaster/JSXComponentMothod";
import { toast } from "react-toastify";

const ShimmerCard = () => (
  <div className="govdash-villageCard-final">
    <div className="village-shimmer" style={{ height: "1rem", marginBottom: "0.6rem" }}></div>
    <div className="village-shimmer" style={{ height: "1.7rem" }}></div>
  </div>
);

const NoDataCard = () => (
  <div className="govdash-villageCard-final govdash-noVillageCard">
    <div className="govdash-noDataIcon">
      <i className="fas fa-village fa-2x"></i>
    </div>
    <div className="govdash-noDataTitle">No Villages Found</div>
    <div className="govdash-noDataDesc">
      {document.querySelector(".govdash-searchInput")?.value ? "Try searching with different keywords" : "No villages available under this Yojana"}
    </div>
  </div>
);

export default function GrantVillageDashboardGrid({ overallDashboardCountData, villages = [], onSelect, isLoading = false }) {
  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState("all"); // all | used | notused

  const themes = ["glass-0", "glass-1", "glass-2", "glass-3", "glass-4"];

  const filteredVillages = useMemo(() => {
    if (!search.trim()) return villages.filter((v) => v?.Village?.trim());

    return villages.filter((v) => v.Village?.toLowerCase().includes(search.toLowerCase()));
  }, [villages, search]);

  const handleExcelExport = () => exportGrantVillageWiseYojanaToExcel(overallDashboardCountData, filteredVillages, "Grant Village-wise Summary");
  const handlePDFExport = () => {
    let exportVillages = [];
    let tabTitle = "";
    let summaryText = "";

    exportVillages = villages;
    // tabTitle = "All Yojana Villages";
    tabTitle = `Total: ${villages.length} `;

    const finalData = search.trim() ? exportVillages.filter((v) => v.Village?.toLowerCase().includes(search.toLowerCase())) : exportVillages;

    const yojanaName = villages[0]?.GramYojnaName || "Village Report";

    const pdfData = [
      { "Village Name": yojanaName },
      { "Village Name": tabTitle },
      // { "Village Name": summaryText },
      { "Village Name": "" },
    ];

    const hasAmount = activeTab !== "notused";

    // pdfData.push({
    //   // "Village Name": "Village Name",
    //   // "Voters": "Voters Count",
    //   // "Labharthi": "Labharthi Count",
    //   ...(hasAmount && { Amount: "Amount" })
    // });

    finalData.forEach((v) => {
      const row = {
        "Village Name": v.VillageNameEnglish || "",
        Voters: v.VillageVoterCount?.toLocaleString() || "0",
        Labharthi: v.BeneficialCount?.toLocaleString() || "0",
      };
      if (hasAmount && v.TotalAmount > 0) {
        row.Amount = "₹" + v.TotalAmount.toLocaleString("en-IN");
      }
      pdfData.push(row);
    });

    exportVillageToPDF(pdfData, `${yojanaName}_${tabTitle.replace(/ /g, "_")}`);
    // toast.success("PDF downloaded successfully!");
  };
  return (
    <div style={{ position: "relative" }}>
      {/* Tabs */}
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
        <h2 className="govdash-sectionTitle">
          Grant Village-wise Summary &nbsp;&nbsp;&nbsp;
          <div className="govdash-totalCountBadge">
            <span className="govdash-totalNumber">{villages.length}</span>
          </div>
        </h2>
        <div className="d-flex gap-2">
          <div className="d-flex gap-3 align-items-center flex-wrap ">
            <div className="govdash-searchWrapper ">
              <i className="fas fa-search"></i>
              <input type="text" placeholder="Search Grant Village Name..." value={search} onChange={(e) => setSearch(e.target.value)} className="govdash-searchInput" />
              {search && (
                <button onClick={() => setSearch("")} className="govdash-clearSearch">
                  <i className="fas fa-times"></i>
                </button>
              )}
            </div>
          </div>
          <div>
            <button disabled={isLoading} onClick={handleExcelExport} className="govdash-excelBtn mt-4">
              <i className="fas fa-file-excel"></i> Export Excel
            </button>
          </div>
        </div>
      </div>

      {/* Grid */}
      <div className="govdash-villageGrid-final">
        {isLoading ? (
          Array(24)
            .fill()
            .map((_, i) => <ShimmerCard key={i} />)
        ) : filteredVillages.length > 0 ? (
          filteredVillages.map((v, idx) => {
            const theme = themes[idx % 5];
            const hasAmount = v?.TotalAmount > 0;

            return (
              <div key={v.id} className={`govdash-villageCard-final yojna-${theme}`} onClick={() => onSelect(v)}>
                <div className="village-header-final">
                  <div className="village-name-final">{v.Village}</div>
                  {/* {v?.VillageVoterCount > 0 && (
                    <div className="voter-badge">
                      {v.VillageVoterCount.toLocaleString()} Voters
                    </div>
                  )} */}
                </div>

                <div className="beneficial-row-final">
                  <span className="label">Yojana</span>
                  <span className="value">{v.GrantYojnaCount.toLocaleString() || "0"}</span>
                </div>

                {hasAmount && (
                  <div className="amount-row-final">
                    {/* ₹{v.TotalAmount.toLocaleString('en-IN')} */}
                    {toIndianCurrencyVillageCard(v.TotalAmount)}
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <NoDataCard />
        )}
      </div>
    </div>
  );
}
